var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4555_184966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79375 12.1172C5.79375 10.3813 6.55625 9.37812 7.85469 9.37812C8.91875 9.37812 9.63281 10.1125 9.70781 11.1078H11.5V10.9375C11.4188 9.08438 9.9 7.8125 7.84063 7.8125C5.33438 7.8125 3.90625 9.45312 3.90625 12.1109V13.2781C3.90625 15.9344 5.32031 17.5437 7.84063 17.5437C9.89375 17.5437 11.4109 16.3062 11.5 14.5141V14.3359H9.70781C9.63281 15.2969 8.93281 15.9766 7.85469 15.9766C6.54219 15.9766 5.79375 15.0078 5.79375 13.2781V12.1172ZM15.3875 12.1172C15.3875 10.3813 16.15 9.37812 17.4469 9.37812C18.5125 9.37812 19.2266 10.1125 19.3016 11.1078H21.0938V10.9375C21.0109 9.08438 19.4937 7.8125 17.4344 7.8125C14.9281 7.8125 13.5 9.45312 13.5 12.1109V13.2781C13.5 15.9344 14.9141 17.5437 17.4344 17.5437C19.4875 17.5437 21.0047 16.3062 21.0938 14.5141V14.3359H19.3016C19.2266 15.2969 18.525 15.9766 17.4469 15.9766C16.1359 15.9766 15.3875 15.0078 15.3875 13.2781V12.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 4.6875C22.2894 4.6875 22.6868 4.85212 22.9799 5.14515C23.2729 5.43817 23.4375 5.8356 23.4375 6.25V18.75C23.4375 19.1644 23.2729 19.5618 22.9799 19.8549C22.6868 20.1479 22.2894 20.3125 21.875 20.3125H3.125C2.7106 20.3125 2.31317 20.1479 2.02015 19.8549C1.72712 19.5618 1.5625 19.1644 1.5625 18.75V6.25C1.5625 5.8356 1.72712 5.43817 2.02015 5.14515C2.31317 4.85212 2.7106 4.6875 3.125 4.6875H21.875ZM3.125 3.125C2.2962 3.125 1.50134 3.45424 0.915291 4.04029C0.32924 4.62634 0 5.4212 0 6.25L0 18.75C0 19.5788 0.32924 20.3737 0.915291 20.9597C1.50134 21.5458 2.2962 21.875 3.125 21.875H21.875C22.7038 21.875 23.4987 21.5458 24.0847 20.9597C24.6708 20.3737 25 19.5788 25 18.75V6.25C25 5.4212 24.6708 4.62634 24.0847 4.04029C23.4987 3.45424 22.7038 3.125 21.875 3.125H3.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.18555,
    y: 4,
    width: 26.5663,
    height: 2,
    rx: 1,
    transform: "rotate(36.3662 2.18555 4)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4555_184966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcOff);
export default __webpack_public_path__ + "static/media/ccOff.3c96a72f97ef19381a9bb7b46bf0e994.svg";
export { ForwardRef as ReactComponent };